import { Box, LabelRows, RED, Rich, cell, money } from "@/components/quote/docKit";
import { imgUrl } from "@/lib/api";

export function BasePackage({ d, t }) {
  const city = (d.client.city || "").trim();
  const rows = t.basePackage.map((r) => (r.label === "Delivery" && city && !/pune/i.test(city) ? { ...r, value: `At cost for ${city} (Free for Pune)` } : r));
  return (
    <Box title="Base PC Build Package included in Total" className="mt-4" testid="quote-base-package">
      <LabelRows rows={rows} />
    </Box>
  );
}

export function PrivilegePackage({ d, t }) {
  return (
    <div className="mt-4 border" style={{ borderColor: RED }} data-testid="quote-privilege-box">
      <div className="text-center text-white py-1.5 text-[14px]" style={{ background: RED }}>
        <b className="text-[17px] tracking-wide">GN PRIVILEGE</b>&nbsp; Warranty, Upgrade and On-site Service package</div>
      <LabelRows rows={t.privilegePerks} labelRed />
      {d.privilegeOptions.map((o) => (
        <div key={o.plan} className="grid grid-cols-[1fr_140px] border-t text-[13px] font-semibold" style={{ ...cell, color: RED, background: d.amcPlan === o.plan ? "#fdecea" : undefined }}
          data-testid={`privilege-price-${o.plan}`}>
          <span className="px-2 py-1">GN PRIVILEGE PACKAGE {o.years} {o.years > 1 ? "YEARS" : "YEAR"} (incl GST 18%){d.amcPlan === o.plan ? "  ✓ Selected" : ""}</span>
          <span className="px-2 py-1 text-right">{money(o.price)}</span>
        </div>
      ))}
    </div>
  );
}

export function ReferenceImage({ d, t }) {
  const src = d.chassisImage || d.referenceImages[0];
  return (
    <Box title="Reference Image" className="print-break mt-6" testid="quote-reference-image">
      <div className="grid grid-cols-[150px_1fr] min-h-[300px]">
        <div className="flex items-center justify-center text-center text-[11px] px-3 border-r" style={{ ...cell, color: RED }}>{t.referenceImageNote}</div>
        <div className="flex items-center justify-center p-4">{src ? <img src={imgUrl(src)} alt="Chassis reference" className="max-h-[340px] object-contain" data-testid="quote-reference-img" /> : null}</div>
      </div>
    </Box>
  );
}

function Bank({ b, upi }) {
  const rows = [["Bank:", b.bank], ["Account type:", b.accountType], ["Account Name:", b.accountName], ["Account Number:", b.accountNumber], ["IFSC Code:", b.ifsc], ["UPI ID:", upi]];
  return (
    <div className="text-[11px]" data-testid={`quote-bank-${b.bank}`}>
      {rows.map(([k, v]) => <div key={k} className="grid grid-cols-[110px_1fr] border-b" style={cell}><span className="px-2 py-[3px]">{k}</span><span className="px-2 py-[3px] text-center">{v}</span></div>)}
    </div>
  );
}

export function Payment({ d, t }) {
  const advance = Math.round(d.grandTotal / 2);
  return (
    <Box className="mt-6" testid="quote-payment">
      <div className="px-2 pt-2 font-bold text-[12px]">PAYMENT DETAILS</div>
      <div className="grid grid-cols-2 gap-x-4 px-2">{t.banks.map((b) => <Bank key={b.accountNumber} b={b} upi={t.upiId} />)}</div>
      <div className="grid grid-cols-[1fr_220px] gap-4 p-2 mt-2">
        <div><div className="font-bold text-[12px] mb-1">PAYMENT TERMS</div>
          <Rich text={t.paymentTerms} tokens={{ advance_amount: money(advance), final_amount: money(d.grandTotal - advance) }} className="text-[11px] leading-relaxed" testid="quote-payment-terms" />
          <img src="/brand/bajaj-emi.png" alt="Bajaj Finserv EMI" className="h-12 mt-3" /></div>
        <div className="flex flex-col items-center"><img src="/brand/upi-qr.png" alt="UPI QR code" className="w-[200px]" data-testid="quote-upi-qr" />
          <img src="/brand/payment-icons.png" alt="Accepted payment methods" className="w-[200px] mt-1" /></div>
      </div>
    </Box>
  );
}

export function Terms({ t }) {
  return (
    <Box className="mt-6" testid="quote-terms">
      <div className="px-3 pt-2 font-bold text-[12px]">TERMS AND CONDITIONS</div>
      <Rich text={t.terms} className="px-3 pb-3 text-[10.5px] leading-snug" />
    </Box>
  );
}
